export const USER_STATUS_ACTIVE = 'Active';
export const USER_STATUS_INACTIVE = 'Inactive';
export const USER_STATUS_DISABLED = 'Disabled';
